const storage = {

    data() {
        return {
          
        }
    },
    methods:{

        setToken(token){
            localStorage.setItem('token', token)
        },
        setUser(user){
            localStorage.setItem('user', JSON.stringify(user))
        },
        getToken(){
            return localStorage.getItem('token')
        },
        getUser(){

            let user = localStorage.getItem('user')
            
            if (user) {
              user = JSON.parse(user)
            }
            return user

        },
        isAdmin(){

            let user = localStorage.getItem('user')
            
            if (user) {
              user = JSON.parse(user)
            }

            return user.profiles[0].name === 'ROLE_ADMIN'

        },
        isUser(){

            let user = localStorage.getItem('user')
            
            if (user) {
              user = JSON.parse(user)
            }

            return user.profiles[0].name === 'ROLE_USER'

        }
    }
}

export default storage


// WEBPACK FOOTER //
// ./src/mixins/storage.js